var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-textarea',{attrs:{"label":"Observações","max-rows":"5","readonly":""},model:{value:(_vm.model.observacoes),callback:function ($$v) {_vm.$set(_vm.model, "observacoes", $$v)},expression:"model.observacoes"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }